import type { PropertyRelation, PropertyType } from '../../composition-functions'
import type { NormalizedPageData } from '../../../contracts/Page'

/** нормализация данных из массива в объект для РЕФЕРЕНСНЫХ полей */
export const propertyValuesRelationNormalizer = (
  arr: PropertyRelation[]
): NormalizedPageData => {
  const obj: any = {}
  arr &&
    arr.forEach((item: PropertyRelation) => {
      const {
        property,
        targetElement = null,
        targetFile = null,
        targetSection = null,
      } = item
      if (property && 'code' in property) {
        const val =
          property.type && property.type === ('FILE' as PropertyType)
            ? targetFile
            : targetElement || targetSection
        if (val) {
          if (obj[property.code]) {
            obj[property.code].push(val)
          } else {
            obj[property.code] = [val]
          }
        }
        if (targetFile) {
          obj[`${property.code}Url`] = targetFile.url
        }
      }
    })
  return obj
}
